import { NOTIFICATION_LEVEL_COLORS } from '../../../api/constants/notifications/notificationLevelColors';
import { Notification } from '../../../store/slices/notification/notificationSlice';

interface Props {
  notification: Notification;
  onClick: (n: Notification) => void;
}

const NotificationItem: React.FC<Props> = ({ notification, onClick }) => {
  const color =
    NOTIFICATION_LEVEL_COLORS[notification.level?.toUpperCase()] || '#3BA2B8';

  return (
    <li
      onClick={() => onClick(notification)}
      style={{
        borderLeft: `4px solid ${color}`,
      }}
      className={`
        flex cursor-pointer flex-col gap-2
        border-t border-stroke px-4.5 py-3
        transition-all duration-200
        hover:bg-gray-2
        dark:border-strokedark
        dark:hover:bg-meta-4
        ${notification.isRead ? 'opacity-80' : 'bg-gray/40 dark:bg-meta-4/20'}
      `}
    >
      {/* 🧾 Header */}
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm font-semibold text-black dark:text-white">
          {notification.title}
        </p>

        {!notification.isRead && (
          <span className="mt-1 h-2.5 w-2.5 rounded-full bg-primary" />
        )}
      </div>

      {/* 📝 Mensaje preview */}
      {notification.message && (
        <p className="line-clamp-2 text-xs leading-relaxed text-body dark:text-bodydark">
          {notification.message}
        </p>
      )}

      {/* 🕒 Fecha */}
      <p className="text-[11px] text-bodydark2">
        {new Date(notification.createdAt).toLocaleString()}
      </p>
    </li>
  );
};

export default NotificationItem;
